const SelectProperty = (state = "" , action) =>{
    switch(action.type){
        case "SELECT_PROPERTY":
        return   action.payload
        default: 
        return state
    }
}
export default SelectProperty;